/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Nav_Products_DescriptionInputs */

const en_inventory_nav_products_description = /** @type {(inputs: Inventory_Nav_Products_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and edit product information`)
};

const es_inventory_nav_products_description = /** @type {(inputs: Inventory_Nav_Products_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver y editar informacion de productos`)
};

/**
* | output |
* | --- |
* | "View and edit product information" |
*
* @param {Inventory_Nav_Products_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_nav_products_description = /** @type {((inputs?: Inventory_Nav_Products_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Nav_Products_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_nav_products_description(inputs)
	return es_inventory_nav_products_description(inputs)
});